module.exports = __webpack_public_path__ + "img/NIS_Incidents.9af8a85c.svg";